import type React from 'react';
import { useMemo } from 'react';

import { CreatePermissionTagButton } from '@vlabs/monokit/features/create-permission-tag';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { withPermissions } from '@vlabs/permissions';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import { PermissionTagListPageFilterMenuButton, PermissionTagListPageSearchInput } from '@vlabs/monokit/entities/permission-tags/filters/';

import st from './PermissionTagListPageHeader.module.sass';
import { routes } from '../../app/routes';

const CreatePermissionTagButtonWithAccess = withPermissions('permission_tags', 'create')(CreatePermissionTagButton);

function PermissionTagListPageHeader(): React.JSX.Element {
  const { t } = useTranslation();
  const pageCtx = usePageContext();
  const history = useHistory();

  const $title = useMemo(() => (
    <div className={st.Title}>
      {pageCtx.getTitleComponent(t('permission-tag-list-page:title'))}
      <PermissionTagListPageSearchInput size={pageCtx.inputSize} />
    </div>
  ), [t, pageCtx]);

  return (
    <PageHeader
      actions={[
        <CreatePermissionTagButtonWithAccess
          key="create-permission-tag"
          onCreatePermissionTag={(permissionTag) => {
            history.push(generatePath(routes.permissionTags.view, { permissionTag }));
          }}
          size={pageCtx.buttonSize}
        />,
        <PermissionTagListPageFilterMenuButton key="permission-tag-list-filters-button" />,
      ]}
      title={$title}
    />
  );
}

export { PermissionTagListPageHeader };
